import React from 'react'
import kubotoLogo from '../../../images/kuboto-logo.jpg'

 const GDPRConsentLeft = () => {
    return (
        <div className="request-left-side">
        <div className="logo-container">
            <img src={kubotoLogo} alt='Kuboto logo' />
        </div>
            <div className="left-text">
                <p>GDPR Consent</p>
            </div>
        </div>
    )
}

export default GDPRConsentLeft
